import { Component,OnDestroy,AfterViewInit,EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TableComponent } from '../../../../shared/component/table/table.component';
import { AgGridTableService, TableHeader } from '../../../../shared/services/ag-grid.service';
import { ApiCallsService } from '../../../../shared/services/api-calls.service';
import { FormModalComponent } from '../../../../shared/component/form-modal/form-modal.component';
import { Subscription } from 'rxjs';
import { ConnectionService } from '../../../../connection.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { environment } from '../../../../../environments/environment';
@Component({
  selector: 'app-application',
  imports: [TableComponent,FormModalComponent],
  templateUrl: './application.component.html',
  styleUrl: './application.component.scss'
})
export class ApplicationComponent implements OnInit ,OnDestroy,AfterViewInit {
  add_Edit:boolean = environment.add_edit
  subscription:Subscription |null
  editData: any;
  lastSegment: any;
  Apiurl:string
  constructor(private aggrid:AgGridTableService,private apiService: ApiCallsService,private ConnectionService: ConnectionService,private router: Router,private toast : ToastService) { }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  ngAfterViewInit(): void {
    //throw new Error('Method not implemented.');
  }
  ngOnInit(): void {
     this.setSegment(this.router.url);

    // ✅ Update dynamically on route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = this.router.url;
        this.setSegment(url);
      });
  
    this.application_table(this.Apiurl);
    this.ConnectionService.editData$.subscribe((data) => {
      this.editData = data;
      this.selectedItem=this.editData.name
      this.applicationId=this.editData._id
    });
  }


  private setSegment(url: string) {
    this.Apiurl = url;
    this.lastSegment = url.split('/').pop() || '';
    this.Apiurl=this.toPascalCase(this.lastSegment)
    this.header=this.Apiurl;

  }
  application_table(apiurl:string):void{
    this.subscription = this.apiService.asset_application(this.toPascalCase(apiurl)).subscribe((response) => {
        const list: Record<string, any>[] = response.Data || [];
        const hiddenKeys: string[] = ["_id", "creation_time_ms", "status","acreation_time_ms"];

        // 🔹 Collect all unique keys from every row (typed as string[])
        const allKeys: string[] = Array.from(
          new Set(list.flatMap((row) => Object.keys(row)))
        );

        const header: TableHeader[] = allKeys.map((key: string) => ({
          name: this.formatHeaderName(key),
          key: key,
          floatingFilter: false,   // ✅ Normal columns can have filter
          filter: true,
          show: !hiddenKeys.includes(key),
          click: true,
          dropdown: false,
        }));

        const transformedResponse = {
          Status: response.Status,
          Message: "Success",
          Data: {
            list,
            total: list.length,
            header
          }
        };
        if (transformedResponse.Data.header && this.add_Edit) {
          transformedResponse.Data.header = this.aggrid.addActionColumn(transformedResponse.Data.header,this.header);
        }
        this.aggrid.processTableData(transformedResponse);
    });
  }

statusMapInput: any;
filterList: any;
header: string;
selectedItem: string;
applicationId: string;

@Output() reloadOptions = new EventEmitter<string>()
@Input() id :string = ""
  editItem(item: string){
    this.apiService.editApplication({ name: item,id: this.applicationId,api_name:this.Apiurl }).subscribe(
      (response: any) => {
        if(response.Status=="Success"){
           this.toast.showToast('Application Update successfully!', 'colored', 6000, 'success');
          this.application_table(this.Apiurl);
        }else{
           this.toast.showToast(response.Message, 'colored', 6000, 'danger');
        }
      }
    );
  }
  
  Additem(name: string) {

    this.apiService.addApplication({ name:name,api_name:this.Apiurl }).subscribe(
      (response: any) => {
        if(response.Status=="Success"){
          this.toast.showToast('Application added successfully!', 'colored', 6000, 'success');
          this.application_table(this.Apiurl);
        }else{
          this.toast.showToast(response.Message, 'colored', 6000, 'danger');
        }
      }
    );
  }
// 🔹 helper function to prettify column names
    private formatHeaderName(key: string): string {
      return key
        .replace(/_/g, " ") // replace underscores with space
        .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize words
    }
    
   openEditModal(name: any) {
    this.selectedItem = name;
  }
  private toPascalCase(str: string): string {
    return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  }
}
